import { render, staticRenderFns } from "./JcdcBreadcrumbs.vue?vue&type=template&id=336b2775"
import script from "./JcdcBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./JcdcBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports